<template>
  <div>
    <input
      :id="inputId"
      v-model="cvcCode"
      :title="$t('enter.card.cvc')"
      :class="{'invalid' : !isValid}"
      type="password"
      placeholder="***"
      maxlength="3"
      autocomplete="cc-csc"
      inputmode="numeric"
      data-private
      @focus="checkReset"
      @input="checkNum"
      @blur="checkLength"
      @keyup.delete="onDelete"
    >
    <label :for="inputId"><span>CVC/CVV</span></label>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    value: [String, Number],
    inputId: String,
    inputSize: {
      type: String,
      default() {
        return '3';
      },
    },
  },
  data() {
    return {
      isValid: true,
      cvcCode: '',
    };
  },
  validations() {
    return {
      cvcCode: {
        required,
        isCvcNum: code => /^[0-9]*$/.test(code),
        isCvcLength: () => this.cvcCode.length === 3,
      },
    };
  },
  methods: {
    checkNum() {
      if (!this.$v.cvcCode.isCvcNum) {
        this.cvcCode = this.cvcCode.slice(0, -1);
      }

      if (this.$v.cvcCode.isCvcLength) {
        this.$emit('input', this.cvcCode);
      }
    },
    checkLength() {
      if (!this.$v.cvcCode.isCvcLength) {
        this.isValid = false;
      }
    },
    checkReset() {
      this.isValid = true;
    },
    onDelete() {
      this.$emit('input', null);
      // Решили не делать в этом поле возврат в предыдущее (CPME-859).
      //   if (_cvcCanPrev) this.$emit('focusPrev')
      //   _cvcCanPrev = this.value ? undefined : true;
    },
    reset() {
      this.cvcCode = '';
    },
  },
};
</script>
